/*---------------------------
| Messaging
---------------------------*/
export const MESSAGING = {
    errors: {
        containsDisallowedTerms: (field = "title") =>
            `Sorry, ${field} contains terms that are not allowed. Please try again.`
    }
};
